import React from 'react';
import omit from 'lodash/omit';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { FormGroup } from 'common/components/form_fields';

const DATE_PICKER_DATE_FORMAT = "MM/DD/YYYY";
const DatePickerField = (field) => {
  const {
    input, onChangeAction, defaultValue, timestamp, meta: { touched, error },
  } = field;

  return (
    <FormGroup field={field}>
      <DatePicker
        {...omit(input, 'value')}
        onBlur={(e) => {
          if (!input.onBlur) {
            return;
          }
          return input.onBlur(
            timestamp? moment(e.target.value, DATE_PICKER_DATE_FORMAT).format() : e.target.value
          );
        }}
        dateFormat={DATE_PICKER_DATE_FORMAT}
        onChange={(e) => {
          if (onChangeAction) {
            onChangeAction(timestamp && e ? e.format() : e);
          }
          input.onChange(timestamp && e ? e.format() : e);
        }}
        selected={input.value ? moment(input.value) : null}
      />
    </FormGroup>
  );
};

export default DatePickerField;
